import { render, staticRenderFns } from "./isoDocument.vue?vue&type=template&id=6b56542e"
import script from "./isoDocument.vue?vue&type=script&lang=js"
export * from "./isoDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b56542e')) {
      api.createRecord('6b56542e', component.options)
    } else {
      api.reload('6b56542e', component.options)
    }
    module.hot.accept("./isoDocument.vue?vue&type=template&id=6b56542e", function () {
      api.rerender('6b56542e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/iso/isoDocument.vue"
export default component.exports